import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppRoutesName } from '../../const/AppRoutesName';

const component = () =>
  import('./dashboard-performance.component').then(
    (m) => m.DashboardPerformanceComponent,
  );

/**
 * Deux entrées de menu, un seul composant : « Performance » (De base, Tier 1) et
 * « Performances » (Expert, Tiers 2 et 3). `data.level` dit laquelle est ouverte.
 */
export const routes: Routes = [
  {
    path: ':shop_uuid/' + AppRoutesName.FR.DASHBOARD_PERFORMANCE,
    loadComponent: component,
    data: { level: 'basic' },
  },
  {
    path: ':shop_uuid/' + AppRoutesName.EN.DASHBOARD_PERFORMANCE,
    loadComponent: component,
    data: { level: 'basic' },
  },
  {
    path: ':shop_uuid/' + AppRoutesName.FR.DASHBOARD_PERFORMANCE_EXPERT,
    loadComponent: component,
    data: { level: 'expert' },
  },
  {
    path: ':shop_uuid/' + AppRoutesName.EN.DASHBOARD_PERFORMANCE_EXPERT,
    loadComponent: component,
    data: { level: 'expert' },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DashboardPerformanceModule {}
